import Link from '@mui/material/Link';
import { Box, Stack, Typography } from '@mui/material';

import { RouterLink } from 'src/routes/components';

// ----------------------------------------------------------------------

type Props = {
  row: any;
  contactDetailHref?: (id: string) => string;
};

// ----------------------------------------------------------------------

export function RowCellDestination({ row, contactDetailHref }: Props) {
  const contactId = (row as any)?.parties?.to?.contactId;
  const toDisplay = (row as any)?.parties?.to?.display;
  const toNumber = (row as any)?.parties?.to?.number;
  const showNumber = !(row as any)?.parties?.to?.numberView;

  return (
    <Box sx={{ gap: 2, display: 'flex', alignItems: 'center' }}>
      <Stack sx={{ typography: 'body2', flex: '1 1 auto', alignItems: 'flex-start' }}>
        <Link
          component={RouterLink}
          href={contactId && contactDetailHref ? contactDetailHref(contactId) : '#'}
          color="inherit"
          underline={contactId ? 'hover' : 'none'}
          sx={{
            cursor: contactId ? 'pointer' : 'default',
            transition: 'all 0.2s ease-in-out',
            '&:hover': {
              color: 'primary.main',
              transform: contactId ? 'translateX(4px)' : 'none',
            },
          }}
        >
          <Typography variant="body2"> {toDisplay ?? ''}</Typography>
          {showNumber && toNumber && (
            <Typography variant="body2" sx={{ fontSize: '0.75rem' }}>
              {toNumber}
            </Typography>
          )}
        </Link>
      </Stack>
    </Box>
  );
}
